export default function compra() {
  return 0
}

export function getCompras(state) {
  return state.compras
}
